import '../Home/Home.css';
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import React, { Component } from "react";
import withNavigateHook from '../../myRoutes';
import axios from 'axios';
import Select from 'react-select';

class Cases extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            startdate: new Date(),
            enddate: new Date(),
            selectedDate: new Date(),
            userRole: "",
            firstname: "",
            lastname: "",
            db: "",
            email: "",
            casecategory: "",
            casename: "",
            caseamount: 0,
            casedescription: "",
            caseoption:"",

        }
    }
    //caseSaveFeedback= "";

    caseCategories = [
        { label: "Birth", value: "Birth" },
        { label: "Death", value: "Death" },
        { label: "Hospitalisation", value: "Hospitalisation" },
        { label: "Monthly fee", value: "Monthly fee" },
        { label: "Other", value: "Other" },
        { label: "Social event", value: "Social event" }
    ]
    componentDidMount = () => {
        this.setState({
            db: this.props.location.state.db, firstname: this.props.location.state.firstname,
            email: this.props.location.state.email, userRole: this.props.location.state.userRole
        });
    }

    appLogout = (e) => {
        e.preventDefault();
        this.props.navigate('/', { state: { db: '', email: '', firstname: '' } });
    }
    goToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                db: this.props.location.state.db, email: this.props.location.state.email,
                firstname: this.props.location.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }
    setCaseCategChange = (e) => {
        //console.log('kkkkk'+e)
        this.setState({ casecategory: e });
    }
    setCaseName = (e) => {
        this.setState({ casename: (this.titleCase(e.target.value)).replaceAll(' ', '_') });
    }

    handleStartDateChange = (event) => {
        this.setState({
            startdate: event.target.value
        });
        //  console.log(event.target.value);
    }

    handleEndDateChange = (event) => {
        this.setState({
            enddate: event.target.value
        });
        // console.log(event.target.value);
    }
    handleAmountChange = (e) => {

        this.setState({
            caseamount: parseFloat(e.target.value)
        })
        //  console.log(e.target.value)
    }
    handleCaseDescription = (e) => {
        this.setState({
            casedescription: e.target.value
        });
    }
    titleCase = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    handleOptionVoluntary = (e) => {
        if (e.target.checked === true) {
            this.setState({ caseoption: "Voluntary" });
            document.getElementById('mandatory').checked = false;
            document.getElementById('caseamountdiv').style.display = 'none';
            
        }
    }
    handleOptionMandatory = (e) => {
        if (e.target.checked === true) {
            this.setState({ caseoption: "Mandatory" });
            document.getElementById('voluntary').checked = false;
            document.getElementById('caseamountdiv').style.display = 'block';
            
        }
    }

    createCase = async () => {
        if (this.state.casecategory === "" || this.state.casename === "" || this.state.startdate === "" || this.state.caseoption === "" ) {
            alert("Please provide all the required details of the case! " + this.state.caseoption)
            return false;
        }
        if((this.state.caseoption ==='Mandatory')&&(this.state.amount === 0)){
            alert('Please enter the amount');
            return false;
        }
        else {
            let config = {
                headers: { 'Accept': 'application/json' },
                params: {
                    "businessname": this.props.location.state.db,
                    "username": this.props.location.state.firstname,
                    "name": this.state.casename,
                    "category": this.state.casecategory,
                    "description": this.state.casedescription,
                    "enddate": this.state.enddate,
                    "startdate": this.state.startdate,
                    "amount": this.state.caseamount,
                    "caseoption":  this.state.caseoption
                }

            }

           // const url = "http://localhost/kimvuka-php/api/saveGroupCase.php";
            const url = "https://testmembership.bktsystems.com/api/saveGroupCase.php";
            const response = await axios.get(url, config);
            this.caseSaveFeedback = response.data;
            // if (Array.isArray(response.data)) {
            //     this.setState({ membersData: response.data });
            // }
            // if (response.data === 'No data found') {
            //     this.setState({ membersCount: response.data })
            // }
            if (response.data.includes("Case sucessfully created.") === true) {
                //  this.caseSaveFeedback = "Case sucessfully created!"
                document.getElementById('successSave').style.display = "block";
                document.getElementById('btnSubmit').disabled = true;

                //alert("Thank you, your registration request has been received. We will contact you once your account is setup.");
            }
            else {
                //alert("There was an error, please try again later.");
                //  this.caseSaveFeedback = "Case creation failed, reason: case exists!"
                document.getElementById('failedSave').style.display = "block";

            }

            console.log(response.data);
        }
    }

    render() {
        return (
            <div id="caseManagementDiv" className='mainDivHome' style={{ border: '2px solid rgb(89, 100, 95)', borderRadius:"10px" }}>
                <div style={{ width: "100%" }}>
                    <span>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "white", fontStyle: "italic" }} onClick={this.goToMenu}>Main Menu</Button>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "#ff7400", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                    </span>
                </div>
                <div style={{ paddingTop: "10px", textAlign: "center" }}>
                    <span style={{ fontStyle: "italic" }} className="businessname"><h4>{this.props.location.state.db}</h4></span>
                    <span style={{ fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                    <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>
                </div>
                <div>
                    {/* <Form> */}
                    <div style={{ textAlign: "center", paddingTop: "5px" }}><Label> <h4>CASE MANAGEMENT </h4></Label></div>
                </div>
                <div style={{ paddingBottom: "10px" }}>
                    <span className=""><h5>CREATE NEW CASE</h5></span>
                </div>
                <Label for='caseoption'>Choose option</Label>
                <FormGroup>
                    
                    <span style={{ paddingRight: "10px" }}>
                        <label>
                            <input style={{ marginRight: ".5rem", paddingLeft: "20px", paddingRight: "20px" }}
                                type='checkbox'
                                name='mandaory'
                                id='mandatory'
                                /* defaultChecked={true} */
                                onChange={this.handleOptionMandatory}
                            />
                            Mandatory
                        </label>
                    </span>

                    <span style={{ paddingLeft: "10px" }}>
                        <label>
                            <input style={{ marginRight: ".5rem", paddingLeft: "20px", paddingRight: "20px" }}
                                type='checkbox'
                                name='voluntary'
                                id='voluntary'
                                onChange={this.handleOptionVoluntary}
                            />
                            Voluntary
                        </label>
                    </span>
                </FormGroup>
                
                <FormGroup>
                    <Label for='category'>Select category</Label>
                    <Select
                        options={this.caseCategories}
                        maxMenuHeight="100%"
                        defaultInputValue=""
                        onChange={opt => this.setCaseCategChange(opt.label)}
                    // styles={this.customStyles}
                    ></Select>
                </FormGroup>
                <FormGroup>
                    <Label for='casename'>Case name</Label>
                    <Input
                        type='text'
                        id='casename'
                        name='casename'
                        onChange={this.setCaseName}
                    // value={this.state.casename}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for='startdate'>Start date</Label>
                    <Input
                        type='date'
                        //  dateFormat="dd-MM-yyyy"
                        selected={this.state.startdate}
                        onChange={this.handleStartDateChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label for='enddate'>End date</Label>
                    <Input
                        type='date'
                        //  dateFormat="dd-MM-yyyy"
                        selected={this.state.enddate}
                        onChange={this.handleEndDateChange}
                    />
                </FormGroup>
                <div id='caseamountdiv'>               
                <FormGroup>
                    <Label for='caseamount'>Amount</Label>
                    <Input
                        type='number'
                        id='caseamount'
                        name='caseamount'
                        value={parseFloat(this.state.caseamount).toFixed(2)}
                        onChange={this.handleAmountChange}
                    />
                </FormGroup>
                </div>
                <FormGroup>
                    <Label for="description">Description</Label>
                    <Input
                        id="description"
                        name="description"
                        type="textarea"
                        rows="1"
                        value={this.state.casedescription}
                        onChange={this.handleCaseDescription}
                    />
                </FormGroup>
                <div id='successSave' style={{ textAlign: "center", color: "green", display: "none" }}><Label style={{ color: "green" }}> <h4>Case successfully created, thank you!</h4></Label></div>
                <div id='failedSave' style={{ textAlign: "center", color: "red", display: "none" }}><Label style={{ color: "red" }}> <h4>Case creation failed, reason: case exists!</h4></Label></div>
                <div style={{ paddingTop: "10px" }}>
                    <Button id="btnSubmit" style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", color: 'white', fontWeight: "bold" }} onClick={this.createCase}>Create</Button>
                </div>
                <div style={{ paddingTop: "20px" }}>
                    <Button style={{ width: "100%", fontWeight: "bold" }}
                        onClick={this.goToMenu}>
                        Close
                    </Button>
                </div>
            </div>
        )
    }

}
export default withNavigateHook(Cases)